import { NetworkStatus } from '@cbridge-utils/network';
import { IUserListStore } from './userList.interface';

export const userListInitialState: IUserListStore = {
  list: [],
  networkStatus: NetworkStatus.None,
  filter: {},
};
